import { Component, Injector, Input, OnInit, inject } from '@angular/core';
import { BreakpointsService, MediaQueryResultMap, BIPPERZ_BREAKPOINTS } from '../../../../shared/services/breakpoint.service';
import { Observable } from 'rxjs';
import { IUser } from '../../../../../assets/types/dtoTypes';
import {AsyncPipe, NgComponentOutlet, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from "@angular/common";

@Component({
  selector: 'app-layout-registration-page',
  templateUrl: './layout-registration-page.component.html',
  styleUrl: './layout-registration-page.component.scss',
  imports: [
    NgSwitch,
    AsyncPipe,
    NgComponentOutlet,
    NgSwitchDefault,
    NgSwitchCase,
    NgIf
  ],
  standalone: true
})
export class LayoutRegistrationPageComponent implements OnInit {
  private breakpointsService = inject(BreakpointsService);
  private injector = inject(Injector);


  @Input() imageSrc: string;

  @Input() imagePosition: 'left' | 'right' = 'left';

  @Input() formComponent;

  @Input() formData: string | IUser;

  breakpoints$: Observable<MediaQueryResultMap>;

  formInjector: Injector;

  ngOnInit() {
    this.formInjector = Injector.create( {
      providers: [ { provide: 'formData', useValue: this.formData } ],
      parent: this.injector,
    } );
  }

  constructor() {
    this.breakpoints$ = this.breakpointsService.observe( [
      BIPPERZ_BREAKPOINTS.s,
      BIPPERZ_BREAKPOINTS.m,
      BIPPERZ_BREAKPOINTS.l,
      BIPPERZ_BREAKPOINTS.xl,
      BIPPERZ_BREAKPOINTS.xxl,
    ] );
  }
}
